import { render, staticRenderFns } from "./NoordBrabant.vue?vue&type=template&id=7b545908&"
var script = {}
import style0 from "./NoordBrabant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoordBrabant.vue"
export default component.exports